import * as yup from "yup";

export const SupportSchema = yup.object().shape({
  firstName: yup.string().required().label("First Name"),
  lastName: yup.string().required().label("Last Name"),
  companyName: yup.string().required().label("Company Name"),
  email: yup.string().email().required().label("Email Address"),
  message: yup.string().required().label("Support Message"),
});
